import * as React from "react";
import { Button, StyleProp, TextInput, ViewStyle } from "react-native";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";

import { Family } from "../../types";

import { Text, View } from "../../components/Themed";
import commonStyles from "../../styles/common";
import useAutosave from "../../common/hooks/useAutosave";

import Move from "../move";
import Video from "../video";
import { Space } from "../../styled-component";

type FamilyFormValues = Pick<Family, "name"> & { moves: number[] };

export interface FamiliesFormProps {
  family?: Family;
  style?: StyleProp<ViewStyle>;
  onSave?: (values: FamilyFormValues) => void;
  disabled?: boolean;
}

function FamilyForm({
  family,
  style,
  onSave = _.noop,
  disabled,
}: FamiliesFormProps) {
  const { control, handleSubmit } = useForm<FamilyFormValues>({
    defaultValues: {
      ...family,
      moves: family?.moves?.map((move) => move.id) || [],
    },
  });
  const [editingMoves, setEditingMoves] = React.useState(false);

  const save = useAutosave({
    onSave: handleSubmit(onSave),
  });

  return (
    <View style={style}>
      <Controller
        control={control}
        name="name"
        rules={{
          required: true,
        }}
        render={({ field: { onChange, onBlur, value } }) => (
          <TextInput
            style={commonStyles.textInput}
            placeholder="Family"
            onBlur={onBlur}
            onChangeText={(text) => {
              onChange(text);
              save();
            }}
            value={value}
            editable={!disabled}
          />
        )}
      />
      <Controller
        control={control}
        name="moves"
        // rules={{
        //   required: true,
        // }}
        render={({ field: { onChange, value, onBlur: _onBlur } }) => (
          <>
            {!disabled && (
              <>
                <Space />

                <Button
                  title={editingMoves ? "Done" : "Edit Moves"}
                  onPress={() => setEditingMoves(!editingMoves)}
                />
              </>
            )}

            {editingMoves ? (
              <Move.Input
                value={value}
                onChange={(nextValue) => {
                  onChange(nextValue);
                  save();
                }}
              />
            ) : (
              <Move.List
                style={commonStyles.grid}
                moves={family?.moves}
                renderItem={({ move: _move }) => (
                  <Move.One
                    style={commonStyles.gridItem}
                    id={_move.id}
                    renderMove={(move) => (
                      <View>
                        <Text
                          style={[
                            commonStyles.textAlignLeft,
                            !move.name ? commonStyles.placeholder : undefined,
                          ]}
                        >
                          {move.name || "Move"}
                        </Text>

                        <Space />

                        <Video.Carousel videos={move.videos} />
                      </View>
                    )}
                  />
                )}
                disabled
              />
            )}
          </>
        )}
      />
    </View>
  );
}

export default FamilyForm;
